/*
 * Wythout — video row (sections/wythout-video-row.liquid).
 *
 * Two IntersectionObservers gate playback; a video plays only when BOTH say
 * yes, which is what lets one script cover both layouts with no breakpoint
 * or resize logic:
 *
 *   A. root = viewport  → "is this video actually on screen?" Pausing on the
 *      way out matters: three offscreen videos left decoding is exactly the
 *      kind of passive cost the perf audit flags.
 *   B. root = the track → "is this the slide the shopper is looking at?"
 *      On desktop the track doesn't scroll, so every item sits fully inside
 *      it and reads as active. On the ≤1024 snap strip only the settled
 *      slide clears the ratio, so the neighbours stay paused for free.
 *
 * Ratios are compared by hand rather than trusting `entry.isIntersecting`:
 * that flag is true at ANY overlap above zero, so with a 0.6 threshold it
 * would report a barely-peeking neighbour as the active slide. The compare
 * values sit just under each threshold to absorb sub-pixel rounding.
 *
 * Reduced motion: nothing autoplays and the native controls stay on, so the
 * shopper starts a video deliberately. The track observer still runs, since
 * the arrows need to know which slide is current — that is navigation, not
 * motion.
 *
 * Markup renders with `controls` so the no-JS case is a normal, usable
 * player; the script strips them only once it has taken over playback.
 */
(function () {
  var VIEWPORT_RATIO = 0.2;
  var ACTIVE_RATIO = 0.55;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.wy-vrow').forEach(function (root) {
    if (root.dataset.vrowInit) return;
    root.dataset.vrowInit = '1';

    var track = root.querySelector('.wy-vrow__track');
    var items = Array.prototype.slice.call(root.querySelectorAll('.wy-vrow__item'));
    if (!track || !items.length) return;

    var autoplay = !reduceMotion.matches;
    var videos = items.map(function (item) { return item.querySelector('video'); });
    var onScreen = items.map(function () { return false; });
    var isActive = items.map(function () { return false; });
    var activeIndex = 0;

    if (autoplay) {
      videos.forEach(function (video) {
        if (video) video.controls = false;
      });
    }

    function sync(i) {
      var video = videos[i];
      if (!autoplay || !video) return;
      if (onScreen[i] && isActive[i]) {
        // Autoplay can still be refused (power saving, platform policy) —
        // swallow it so it never surfaces as an unhandled rejection.
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    }

    // --- Arrows -------------------------------------------------------
    // Wrap-around (the modulo the hero rotator uses) so neither arrow ever
    // needs disabling — a disabled button would drop focus mid-interaction.
    function goTo(n) {
      var idx = ((n % items.length) + items.length) % items.length;
      track.scrollTo({
        left: items[idx].offsetLeft - items[0].offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    var prev = root.querySelector('.wy-vrow__arrow--prev');
    var next = root.querySelector('.wy-vrow__arrow--next');
    if (prev) prev.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });

    // --- Observers ----------------------------------------------------
    var trackObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = items.indexOf(entry.target);
        if (i === -1) return;
        isActive[i] = entry.intersectionRatio >= ACTIVE_RATIO;
        if (isActive[i]) activeIndex = i;
        sync(i);
      });
    }, { root: track, threshold: [0, ACTIVE_RATIO, 0.6] });

    items.forEach(function (item) { trackObserver.observe(item); });

    if (!autoplay) return;

    var viewportObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = items.indexOf(entry.target);
        if (i === -1) return;
        onScreen[i] = entry.intersectionRatio >= VIEWPORT_RATIO;
        sync(i);
      });
    }, { threshold: [0, VIEWPORT_RATIO, 0.25] });

    items.forEach(function (item) { viewportObserver.observe(item); });
  });
})();
